import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Barcode1 from '../../../../content/images/elements/barcode.png';
import { numberWithCommas } from '../../../../utils/consts';
import { bookingApi } from '../../../../services/apis';
let parsedQueryStr = '';
export class PriceSection extends Component {
  constructor(props) {
    super(props);
    parsedQueryStr = Object.fromEntries(new URLSearchParams(location.search));
    this.state = {
      currentIndex: 0,
      currentFlight: {},
      noResult: false,
    };
  }
  componentDidMount = () => {
    this.fetchFlightInfo();
  };
  fetchFlightInfo() {
    bookingApi.getBookingById(parsedQueryStr.id).then((currentFlight) => {
      if (currentFlight.payload.data) {
        this.setState({ currentFlight: currentFlight.payload.data }, () =>
          !parsedQueryStr.print || parsedQueryStr.print != 1
            ? //  automatically creat pdf and download it
              this.downLoadPDF()
            : null,
        );
      } else {
        this.setState({ currentFlight: {}, noResult: true });
      }
      if (!parsedQueryStr.print || parsedQueryStr.print != 1)
        setTimeout(() => {
          window.close();
        }, 2000);
    });
  }

  render() {
    let { currentFlight, currentIndex } = this.state;
    let passenger =
      Object.entries(currentFlight).length > 0 && currentFlight.flights
        ? currentFlight.passengers[currentIndex]
        : false;
    return (
      <div className="bg-white border  border-radius-xl ">
        <div className=" d-flex justify-content-center py-2">
          <img
            src={Barcode1}
            alt="Logo"
            style={{ width: '43vw', height: '5vh' }}
          />
        </div>
        <div className=" d-flex text-primary-light pt-3 pb-1">
          <div className="col-4 d-flex flex-column justify-content-center align-items-center">
            <FormattedMessage id="booking.fareprice" />
            <span className="pt-2 text-secondary">
              {passenger ? numberWithCommas(passenger.price.baseFare) : ''}
            </span>
          </div>
          <div className="col-4 d-flex flex-column justify-content-center align-items-center">
            <FormattedMessage id="booking.tax" />
            <span className="pt-2 text-secondary">
              {passenger ? numberWithCommas(passenger.price.tax) : ''}
            </span>
          </div>
          <div className="col-4 d-flex flex-column align-items-center">
            <FormattedMessage id="profile.totalAmount" />
            <span className="pt-2 text-secondary">
              {passenger ? numberWithCommas(passenger.price.totalPrice) : ''}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(connect(mapStateToProps, {})(PriceSection));
